<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   :width="width"
   :height="height"
   viewBox="0 0 360 400"
   version="1.1"
   id="svg1118"
   sodipodi:docname="tongue_N_round_4.svg"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" result="bblur" />
         <feColorMatrix in="bblur" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" result="blur" />
      </filter>
  </defs>
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.98994949"
     inkscape:cx="49.982147"
     inkscape:cy="187.25371"
     inkscape:document-units="px"
     inkscape:current-layer="layer1"
     inkscape:document-rotation="0"
     showgrid="false"
     units="px"
     scale-x="1"
     inkscape:window-width="1252"
     inkscape:window-height="755"
     inkscape:window-x="0"
     inkscape:window-y="23"
     inkscape:window-maximized="0" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <path
       id="outside"
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.996347;stroke-opacity:1"
       d="M 0.49804688 0.49804688 L 0.49804688 399.50195 L 359.50195 399.50195 L 359.50195 0.49804688 L 0.49804688 0.49804688 z M 233.96289 22.080078 C 247.52002 21.873251 260.90548 30.236107 277.40234 62.482422 C 321.97234 149.60316 281.48543 376.90158 179.61719 377.91992 C 76.730624 373.84657 38.567943 149.17576 82.785156 61.927734 C 117.03658 -5.6560941 143.67085 33.411903 182.42383 33.505859 C 203.01135 33.555773 218.59814 22.314482 233.96289 22.080078 z " />
   <path
       d="M 180 8.7871094 A 112.69226 31.88006 0 0 0 67.308594 40.667969 A 112.69226 31.88006 0 0 0 86.068359 58.279297 C 118.85336 -2.0964101 144.91382 34.75285 182.40625 34.84375 C 219.8131 34.934442 240.5749 -2.535377 273.83203 58.322266 A 112.69226 31.88006 0 0 0 292.69141 40.667969 A 112.69226 31.88006 0 0 0 180 8.7871094 z "
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       id="mouth" />
  <g id="cover_layer">
     <path
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:1.90083px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 94.462462,58.4492 C 55.556256,135.21771 89.135238,332.90336 179.66392,336.48745 269.29659,335.59142 304.91939,135.59386 265.70277,58.937354 234.7366,-1.5920404 216.23181,33.523935 182.13352,33.441265 148.03522,33.358594 124.59988,-1.0170174 94.462462,58.4492 Z"
       id="cover"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="scsss" />
  </g>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="body_layer">
   <path
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:2.14295px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 83.566908,63.036209 C 39.704928,149.5833 77.561115,372.44965 179.62111,376.49027 280.67096,375.48011 320.83131,150.00736 276.61937,63.586543 241.70881,-4.652933 220.84693,34.936027 182.40528,34.842826 143.96363,34.749625 117.54315,-4.004665 83.566908,63.036209 Z"
       id="body"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="scsss" />
    <path
       inkscape:connector-curvature="0"
       id="lg"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 180.53558,280.74532 c -27.19743,-0.0659 -54.22308,8.90067 -82.767572,28.27539 6.869612,13.86651 14.804582,26.26486 23.771482,36.53907 43.25287,-15.4908 81.99632,-14.23445 117.3457,-0.36914 9.33579,-10.92224 17.55656,-24.22551 24.6211,-39.10938 -28.92857,-16.36088 -56.03701,-25.26986 -82.97071,-25.33594 z" />
    <path
       id="he"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 183.31879,334.10665 c -19.65629,-0.21062 -40.3214,3.31942 -62.12696,11.0918 16.1618,18.66511 35.69568,30.41119 58.41211,31.31054 23.01073,-0.23002 42.86265,-12.10184 59.28125,-31.31835 -17.63179,-7.00198 -36.10561,-10.87546 -55.5664,-11.08399 z"
       inkscape:connector-curvature="0" />
    <path
       inkscape:connector-curvature="0"
       id="k-bl-li"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 233.52973,23.509006 C 218.28841,23.741527 202.82685,34.892503 182.40473,34.84299 143.96308,34.74979 117.54307,-4.004525 83.566828,63.036349 79.939772,70.193153 76.883083,78.298077 74.363707,87.118381 157.10735,102.14131 223.40255,97.042159 285.67035,87.012912 283.1908,78.431089 280.18304,70.552635 276.61957,63.587131 260.25524,31.599876 246.97794,23.30384 233.52973,23.509006 Z" />
    <path
       inkscape:connector-curvature="0"
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 285.75238,87.313693 -38.67969,5.236328 c 13.75563,76.225489 9.82979,138.993609 -1.02929,204.279289 l 17.36328,9.45703 c 13.9136,-29.24025 23.34104,-64.61839 27.88867,-100.1582 1.94088,-20.68937 2.77239,-41.47008 2.89258,-61.20313 -0.79754,-20.99317 -3.57669,-40.67793 -8.43555,-57.611317 z" />
    <path
       inkscape:connector-curvature="0"
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 74.299254,87.352756 c -4.510863,15.876314 -7.254778,34.097454 -8.277344,53.521474 -0.03224,22.20283 0.803063,45.80822 3.089844,69.19142 4.789439,35.20416 14.378044,70.00796 28.496094,98.62304 L 113.45551,298.64963 C 103.32903,229.1586 100.21677,165.15282 112.00043,92.923068 Z" />
    <path
       sodipodi:nodetypes="cccccc"
       inkscape:connector-curvature="0"
       d="M 113.45814,298.65084 C 103.33166,229.1599 100.21912,165.15116 112.00278,92.9214 c 49.8885,5.559577 93.82198,4.169466 135.07476,-0.346263 13.74955,76.212793 9.82392,138.976643 -1.03377,204.254303 -50.69744,-23.09934 -86.29482,-20.59643 -132.58563,1.82109 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.769456;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="st-sp" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>